/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
// component
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ControlTable } from "../../../components/Table";
import SelectClientInfo from "../../../components/BillForm/SelectClientInfo";
import { forEach, isEmpty } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import { toast } from "../../../utils/toast";
import { createInvoiceByTaxInvoice } from "../../../apis/invoices";
import ToolTip from "../../../components/ToolTip/ToolTip";


const TaxInvoiceToTradeInvoice = ({
  open,
  setOpen,
  list,
  setList,
  type = 'sales'
}) => {
  const [fields, setFields] = useState([]);
  const [_list, _setList] = useState([])

  useEffect(() => {
    setFields([
      { title: "전송일자", key: "issueDate" },
      { title: "작성일자", key: "writeDate" },
      { title: "상호", key: type === 'sales' ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: type === 'sales' ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: type === 'sales' ? "byrBizNo" : "supBizNo",
        transform: 'comNum'
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
      {
        title: '발급가능여부',
        key: 'issuable',
        onValue: (value, field, data) => {
          let text = ""
          if (!isEmpty(data.mappedInvoices) && !isEmpty(data.client)) {
            text = <p>이미 매핑된 <span className="color-red-100">거래명세서</span>가 있습니다.</p>
          } else if (isEmpty(data.mappedInvoices) && isEmpty(data.client)) {
            text = <p>매핑된 <span className="color-red-100">거래처가</span>가 없습니다.</p>
          } else if (!isEmpty(data.mappedInvoices) && isEmpty(data.client)) {
            text = (<>
              <p>이미 매핑된 <span className="color-red-100">거래명세서</span>가 있습니다.</p>
              <p>매핑된 <span className="color-red-100">거래처가</span>가 없습니다.</p>
            </>)
          }

          return (
            value
              ?
              <span className='color-green-100'>
                가능
              </span>
              :
              <>
                <span className="color-red-100">
                  불가능
                </span>
                <ToolTip className="ml-4" position="left" tooltiptext={text} />
              </>
          )
        }
      }
    ])
  }, [type])

  const cancel = () => {
    setOpen(false);
    setList([])
  };

  useEffect(() => {
    _setList(list.map((item) => ({
      ...item,
      issuable: !(isEmpty(item.client) || !isEmpty(item.mappedInvoices))
    })))
  }, [list])

  const handleSubmit = () => {
    systemAlert(`${_list.length}건의 전자(세금)계산서를 거래명세서로 발급하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '발급',
          onClick: () => {
            const promiseList = []
            viewLoading(true)
            forEach(_list, item => {
              if (item.issuable) {
                promiseList.push(createInvoiceByTaxInvoice(item.idx, item.client.idx))
              }
            })
            Promise.all(promiseList)
              .then(() => {
                toast.info('거래명세서가 발급되었습니다.')
                setOpen(false)
                setList([])
              })
              .finally(() => {
                viewLoading(false)
              })
          }
        }
      ]
    })
  }

  const getTitle = () => {
    return (
      <span>선택된 전자 (세금)계산서 <span className="color-main-100 font-bold">{list.length}</span>건</span>
    )
  }

  const getDisabled = () => {
    let disabled = true

    forEach(_list, item => {
      if (item.issuable) {
        disabled = false
      }
    })

    return disabled
  }

  return (
    <>
      <Modal size="x-lg" isOpen={open} close={cancel} className="p-0">
        <div className="tax-invoice-to-trade-invoice-page">
          <ModalHeader>거래명세서 발급하기</ModalHeader>
          <p className="description">거래명세서 발급이 불가한 경우 거래명세서 발급이 제외됩니다.</p>
          <ControlTable
            title={getTitle()}
            fields={fields}
            list={_list}
          />
          <div className="submit-button-wrap float-right">
            <Button
              className="button"
              size="lg"
              label="취소"
              color="text"
              action={cancel}
            />
            <Button
              className="button"
              size="lg"
              label="작성완료"
              disabled={getDisabled()}
              action={handleSubmit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TaxInvoiceToTradeInvoice;
